import i18n from "./index";
import { isBinapsisBrand } from "../utils/utils";

const ES_DAYS = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

/** Índices 0 (domingo) … 6 (sábado) para iterar días localizados. */
export const WEEK_DAY_INDICES = [0, 1, 2, 3, 4, 5, 6];

export function getLocalizedDayName(dayIndex) {
  const index = Number(dayIndex);
  if (Number.isNaN(index) || index < 0 || index > 6) return "";
  if (!isBinapsisBrand()) return ES_DAYS[index];
  return i18n.t(`schedule.days.${index}`, { defaultValue: ES_DAYS[index] });
}

export function getLocalizedScheduleType(type) {
  const key = type || "habitual";
  const defaults = { habitual: "Habitual", occasional: "Ocasional", blocked: "Bloqueado" };
  if (!isBinapsisBrand()) return defaults[key] || key;
  return i18n.t(`schedule.types.${key}`, { defaultValue: defaults[key] || key });
}

export function getLocalizedAppointmentType(type) {
  const defaults = { private: "Particular", insurance: "Obra Social" };
  if (!isBinapsisBrand()) return defaults[type] || type;
  return i18n.t(`schedule.appointmentTypes.${type}`, {
    defaultValue: defaults[type] || type,
  });
}

export function getLocalizedConsultationMode(mode) {
  const defaults = {
    in_person: "Presencial",
    virtual: "Virtual",
    both: "Presencial y virtual",
  };
  if (!mode) return "";
  if (!isBinapsisBrand()) return defaults[mode] || mode;
  return i18n.t(`schedule.consultationModes.${mode}`, {
    defaultValue: defaults[mode] || mode,
  });
}
